import { create } from 'zustand';
import { AssistantPaymentOptionsState } from './interfaces';

const useAssistantPaymentOptionsStore = create<AssistantPaymentOptionsState>()(
  (set) => ({
    sendEmail: true,
    chargeDeliveryCost: true,
    actions: {
      setSendEmail: (to: boolean) => {
        set({ sendEmail: to });
      },
      setChargeDeliveryCost: (to: boolean) => {
        set({ chargeDeliveryCost: to });
      },
      cleanValues: () => {
        set({
          sendEmail: true,
          chargeDeliveryCost: true,
        });
      },
    },
  }),
);

export const useAssistantPaymentOptions = () =>
  useAssistantPaymentOptionsStore((state) => {
    return {
      sendEmail: state.sendEmail,
      chargeDeliveryCost: state.chargeDeliveryCost,
    };
  });

export const useAssistantPaymentActions = () =>
  useAssistantPaymentOptionsStore((state) => state.actions);
